import { useCallback, useEffect } from 'react'

import infoIcon from '../../components/images/info-icon-orange.svg'
import { handleEscapeKey } from 'sites/auctions/components/utils'

import css from '../../components/sass/confirmmodal.module.scss'
import themeCss from '../../components/sass/theme.module.scss'

// Confirms the user's intent before PreviewPublish sends an approval request to Solicitation Review.
export default function ConfirmSolicitationRequest({setShowConfirmModal, sendToSolicitation}) {

  // Keep dismissal behavior consistent across the admin confirmation modals.
  const toggleModal = useCallback(() => {
    setShowConfirmModal(false)
  }, [setShowConfirmModal])

  useEffect(() => {
    const onKeyDown = (event) => handleEscapeKey(event, toggleModal)
    // Allow the Escape key to dismiss the modal while it is mounted.
    document.addEventListener('keydown', onKeyDown)
    // Remove the listener when the modal is dismissed or unmounted.
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [toggleModal])

  // Use PreviewPublish's existing request function, then return the user to the publish controls.
  const performConfirm = async () => {
    await sendToSolicitation()
    setShowConfirmModal(false)
  }

  return (
    <div className={css['modal-container']}>
      <div className={themeCss['modal-background']} onClick={() => toggleModal()}> </div>
      <div className={`${css['modal-content']} ${css['top-orange-border']}`}>

        <div className={css['simple-body']}>
          <img src={infoIcon} alt="Warning Exclamation" />
          <div className={css['simple-text']}>
            <h3>Submit this auction for solicitation review?</h3>
            <p>Once Solicitation Review approves this auction, you won't be able to edit:</p>
            <ul>
              <li>Auction title, description, fund name, fund number, and marketing effort</li>
              <li>Item titles, descriptions, fair market values, and fixed item purchase prices</li>
              <li>Add new items</li>
            </ul>
            <p>Please make sure this content is final before submitting.</p>
          </div>
        </div>

        <div className={css['button-options']}>
          <button className={`${themeCss['button']} ${themeCss['FilledWhite']} ${themeCss['centered-button']}`}
            onClick={() => toggleModal()}>Cancel</button>

          <button className={`${themeCss['FilledBlue']} ${themeCss['button']} ${themeCss['centered-button']} ${css['modal-buttontext-fixing']}`}
            onClick={() => performConfirm()}>Submit for Review</button>
        </div>
      </div>
    </div>
  )
}
